import React, {useEffect, useState} from 'react'
import styled, {css, withTheme} from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import type { ComponentType, HTMLAttributes, ReactNode } from 'react';
import { getColor } from '../utils/styled';
import defaultIcons from '../refs/Icons';

type SvgComponent = ComponentType<any>;

interface IconProps extends HTMLAttributes<HTMLElement> {
  icon?: string;
  children?: ReactNode;
  clickable?: boolean;
  color?: string;
  customIcon?: boolean;
  theme: DefaultTheme;
  size?: number;
  fontSize?: number;
}

const IconComponent = ({theme,icon,size,fontSize,children, clickable, color, customIcon,...rest}: IconProps) => {
    const [Svg,setSvg] = useState<SvgComponent | null>(null);

    useEffect(() => {
        if (icon && (theme?.svgIcons || {})[icon] && typeof theme?.svgLoader === 'function') {
            theme.svgLoader(icon).then((i: any) => setSvg(i?.default as SvgComponent));
        } else {
            setSvg(null);
        }
    }, [icon, theme]);

    if (icon && (theme?.svgIcons || {})[icon]) {
      if (Svg) {
        return <Svg {...rest} />
      } else {
        return null
      }
    }
    const iconGlyph = icon ? (theme?.icons?.[icon] ?? defaultIcons[icon as keyof typeof defaultIcons]) : undefined;
    return <span {...rest}>{iconGlyph || (customIcon && icon)}{children}</span>
}

export const Icon = styled(withTheme(IconComponent))`
  font-family: '${props => props.theme?.resolveFont?.(props.icon) || 'purview-icons-v2'}' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${props => props.size && `
    width: ${props.size}px;
    height: ${props.size}px;
  `}
  ${props => props.size && !props.fontSize &&  `
    font-size: ${props.size}px;
  `}

  ${props => props.fontSize &&  `
    font-size: ${props.fontSize}px;
  `}

  ${props => !props.fontSize && !props.size &&  `
    font-size: 12px;
    width: 12px;
    height: 12px;
  `}

  ${props => props.color && css`
    color: ${getColor(props.color)};
  `}
  

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none; 
  ${props => (props.clickable || props.onClick) && `
    cursor: pointer;
    &:hover {
      opacity: 0.85;
    }
  `}
`